import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=2f3ec882&scoped=true&"
import script from "./NavigationMenu.vue?vue&type=script&lang=ts&"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=2f3ec882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ec882",
  null
  
)

export default component.exports